import { Box, styled } from "@mui/material";

export const StyledIconLink = styled(Box)`
  padding: ${({ theme }) => theme.spacing(2, 1, 1)};
  text-align: center;

  a {
    color: ${({ theme }) => theme.palette.text.secondary};
    display: block;
    font-size: ${({ theme }) => theme.typography.size.xsmall};

    &:hover,
    &:focus,
    &.active:hover,
    &.active:focus {
      color: ${({ theme }) => theme.palette.biarri.primary.red};
    }

    .icon {
      display: inline-flex;
      border-radius: ${({ theme }) => theme.shape.borderRadius}px;
      padding: ${({ theme }) => theme.spacing(0.5)};
      margin-bottom: ${({ theme }) => theme.spacing(0.5)};
    }

    &.active .icon {
      color: ${({ theme }) => theme.palette.biarri.primary.red};
      background-color: ${({ theme }) => theme.palette.common.white};
    }
  }
`;
